import React, { useState } from 'react';
import {
  Dialog,
  Heading,
  Tab,
  TabList,
  TabPanel,
  Tabs,
} from 'react-aria-components';
import { AnimatePresence } from 'motion/react';
import { Button } from '@magicbrief/ui/src/components/button';
import { MotionModalOverlay } from 'src/components/AriaModal/components/MotionModalOverlay';
import { MotionModal } from 'src/components/AriaModal/components/MotionModal';
import {
  InsightsDemoAccountCreate,
  InsightsDemoAccountsList,
} from './components/InsightsDemoAccount';
import { InsightsAITagging } from './components/InsightsAITagging';

interface InsightsAdminModalProps {
  onClose: () => void;
}

export const InsightsAdminModal: React.FC<InsightsAdminModalProps> = ({
  onClose,
}) => {
  const [isInternalOpen, setIsInternalOpen] = useState(true);
  const [tab, setTab] = useState('ai-tagging');

  return (
    <AnimatePresence onExitComplete={onClose}>
      {isInternalOpen && (
        <MotionModalOverlay isOpen onOpenChange={(s) => setIsInternalOpen(s)}>
          <MotionModal className="w-1/3 rounded-xl bg-white pb-6 pt-4">
            <Dialog className="space-y-2">
              <Heading className="px-6 text-xl font-semibold text-primary">
                Insights Administration
              </Heading>
              <div className="pb-3">
                <Tabs
                  selectedKey={tab}
                  defaultSelectedKey="list"
                  onSelectionChange={(key) => {
                    setTab(key as typeof tab);
                  }}
                  className="flex min-h-0 flex-col gap-3"
                >
                  <TabList
                    aria-label="Insights Administration"
                    className="flex flex-row gap-3 border-b border-solid border-purple-100 px-6 pb-2 text-xs font-semibold text-primary/40"
                  >
                    <Tab
                      className="cursor-pointer outline-none focus:outline-none focus-visible:outline-none selected:text-purple-800 disabled:text-gray-400"
                      id="ai-tagging"
                    >
                      AI Tagging
                    </Tab>
                    <Tab
                      className="cursor-pointer outline-none focus:outline-none focus-visible:outline-none selected:text-purple-800 disabled:text-gray-400"
                      id="list"
                    >
                      Demo Account(s)
                    </Tab>
                    <Tab
                      id="create"
                      className="cursor-pointer outline-none focus:outline-none focus-visible:outline-none selected:text-purple-800"
                    >
                      Create New Demo Account
                    </Tab>
                  </TabList>
                  <TabPanel
                    id="ai-tagging"
                    className="flex min-h-0 flex-auto px-6"
                  >
                    <InsightsAITagging />
                  </TabPanel>
                  <TabPanel id="list" className="flex min-h-0 flex-auto px-6">
                    <InsightsDemoAccountsList />
                  </TabPanel>
                  <TabPanel id="create" className="flex min-h-0 flex-auto px-6">
                    <InsightsDemoAccountCreate />
                  </TabPanel>
                </Tabs>
              </div>
              <div className="border-t border-solid border-purple-100 px-6 pt-4">
                <Button
                  variant="secondary"
                  onPress={() => setIsInternalOpen(false)}
                >
                  Close
                </Button>
              </div>
            </Dialog>
          </MotionModal>
        </MotionModalOverlay>
      )}
    </AnimatePresence>
  );
};
